import { computed } from 'vue-demi';

export const vModelProps = {
  value: {},
  modelValue: {}
};

export const vModelEmits = ['input', 'update:modelValue'];

export default function (props, emits) {
  const isVue3PropUsed = computed(() => typeof props.modelValue !== 'undefined');

  const binding = computed({
    get() {
      return props ? (isVue3PropUsed.value ? props.modelValue : props.value) : undefined;
    },
    set(newValue) {
      if (isVue3PropUsed.value) {
        emits('update:modelValue', newValue);
      } else {
        emits('input', newValue);
      }
    }
  });

  return binding;
}
